export const sumValues = (data) => {
  let sum = 0;
  for (const year in data) {
    if (year === "title") {
      continue;
    }
    sum += data[year];
  }
  return sum;
};
